import React from 'react';

import ContainerTwoColumns from '@/components/Containers/ContainerTwoColumns';
import Section from '@/components/Sections/Section';

import ContactForm from '../../Blocks/ContactForm/ContactForm';

import './ContactUs.scss';

const ContactUs = () => (
  <Section backgroundColor="white" id="contact-form" hasVerticalLine customClass="ContactUs_section">
    <ContainerTwoColumns
      leftContent={
        <>
          <h3>Contact us</h3>
          <address className="ContactUs_address body-1">
            Sales and general inquires <br />
            <a href="mailto:contact@iflexion.com" className="text-link body-1">
              contact@iflexion.com
            </a>
          </address>
        </>
      }
      rightContent={<ContactForm />}
    />
  </Section>
);

export default ContactUs;
